// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Utils
import { now } from '../../utils/react/propsComparisons';

// Actions
import * as elementService from '../elementService';
import { fetchElementModalAncestors } from './elementModalActions';

// Selectors
import elementModalSelector from './elementModalSelector';
import {
    getAsyncEntityFetchedTime,
    isAsyncEntityFetched,
    isAsyncEntityFetching,
    shouldFetchAsyncResource,
} from '../../utils/services/http/asyncResource/asyncResourceUtils';

// Prop comparison functions
const socketHasReconnected = now('socketConnected');

const shouldFetchElement = (oldProps, nextProps) => {
    const { currentElementResourceEntity, localCacheHydrationTimestamp } = nextProps;

    if (isAsyncEntityFetching(currentElementResourceEntity)) return false;

    if (shouldFetchAsyncResource(currentElementResourceEntity)) return true;

    if (!isAsyncEntityFetched(currentElementResourceEntity) && socketHasReconnected(oldProps, nextProps)) return true;

    if (!localCacheHydrationTimestamp) return false;

    // If the current element was fetched in the last session, we should re-fetch it
    return getAsyncEntityFetchedTime(currentElementResourceEntity) < localCacheHydrationTimestamp;
};

const shouldFetchAncestors = (oldProps, nextProps) =>
    // We need the current element in order to know the parent
    nextProps.element && !nextProps.isRenderedParentElementFetchingOrFetched;

const mapDispatchToProps = (dispatch) => ({
    dispatchFetchElement: ({ elementId, permissionId }) =>
        dispatch(
            elementService.fetchElements({
                elementIds: [elementId],
                permissionIdsOverride: [permissionId],
                force: true,
            }),
        ),
    dispatchFetchAncestors: ({ elementId, permissionId }) =>
        dispatch(fetchElementModalAncestors(elementId, permissionId)),
});

export default (DecoratedComponent) => {
    @connect(elementModalSelector, mapDispatchToProps)
    class elementModalElementFetcher extends React.Component {
        componentWillMount() {
            const { dispatchFetchElement, elementId, urlPermissionId, dispatchFetchAncestors } = this.props;

            if (shouldFetchAncestors(this.props, this.props)) {
                dispatchFetchAncestors({ elementId, permissionId: urlPermissionId });
            }

            if (shouldFetchElement(this.props, this.props)) {
                dispatchFetchElement({ elementId, permissionId: urlPermissionId });
            }
        }

        componentWillReceiveProps(nextProps) {
            const { dispatchFetchElement, elementId, urlPermissionId, dispatchFetchAncestors } = nextProps;

            // If we don't have a element ID or we don't have a socket connection then don't fetch the board
            if (!elementId) return;

            if (shouldFetchAncestors(this.props, nextProps)) {
                dispatchFetchAncestors({ elementId, permissionId: urlPermissionId });
            }

            if (shouldFetchElement(this.props, nextProps)) {
                dispatchFetchElement({ elementId, permissionId: urlPermissionId });
            }
        }

        render() {
            return <DecoratedComponent {...this.props} />;
        }
    }

    elementModalElementFetcher.propTypes = {
        elementId: PropTypes.string,
        urlPermissionId: PropTypes.string,
        element: PropTypes.object,

        currentElementResourceEntity: PropTypes.object,
        isElementFetched: PropTypes.bool,
        socketConnected: PropTypes.bool,

        isRenderedParentElementFetchingOrFetched: PropTypes.bool,

        dispatchFetchElement: PropTypes.func,
        dispatchFetchAncestors: PropTypes.func,
    };

    return elementModalElementFetcher;
};
